import { alertActions as baseAction } from '../alert.actions';

const actions = {
  
};

export const alertActions = Object.assign(baseAction, actions)
